var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 21.3322L9.84133 20.4458C10.796 19.4234 11.6547 18.4534 12.4187 17.5307L13.0493 16.7527C15.6827 13.435 17 10.8017 17 8.85547C17 4.70112 13.4187 1.3335 9 1.3335C4.58133 1.3335 1 4.70112 1 8.85547C1 10.8017 2.31733 13.435 4.95067 16.7527L5.58133 17.5307C6.67125 18.8366 7.81156 20.1038 9 21.3322Z",
    stroke: "#034A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0013 11.9313C10.8423 11.9313 12.3346 10.5358 12.3346 8.81428C12.3346 7.0928 10.8423 5.69727 9.0013 5.69727C7.16035 5.69727 5.66797 7.0928 5.66797 8.81428C5.66797 10.5358 7.16035 11.9313 9.0013 11.9313Z",
    stroke: "#034A73",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.10c9258fe414f1251deb47eb7a0dbc8e.svg";
export { ForwardRef as ReactComponent };